import React from 'react';
import { css } from '@emotion/react';
import CustomersIcon from '$/images/3_Customer_stories.svg';
import RealestateIcon from '$/images/4_Real.svg';
import RealestateTechIcon from '$/images/5_Real.svg';
import CustomerSuccessIcon from '$/images/6_Customer_success.svg';
import LeadIcon from '$/images/7_Lead.svg';
import CourseIcon from '$/images/8_Course.svg';
import config from '$/config';

export interface MarketingMenuChild {
  title: string;
  description: string;
  icon: JSX.Element;
  link: string;
  target?: string;
}
export interface MarketingMenu {
  textColor?: string;
  bgColor?: string;
  children: MarketingMenuChild[];
}

const UseCasesMenu: React.FC<{ target?: string }> = ({ target }): JSX.Element => {
  const SubMenuList: MarketingMenu[] = [
    {
      textColor: 'teal-1',
      bgColor: 'bg-teal-8',
      children: [
        {
          title: 'Customer stories?',
          description: `Don't take our word for it. See what our customers say.`,
          icon: <img src={CustomersIcon} />,
          link: `${config.URL_MARKETING_SITE}/customers`,
        },
        {
          title: 'SaaS: Customer success',
          description: `Deliver personalized onboarding and training at scale, as soon as customers need it`,
          icon: <img src={CustomerSuccessIcon} />,
          link: `${config.URL_MARKETING_SITE}/saas-customer-success`,
        },
        {
          title: 'SaaS: Lead gen and marketing',
          description: `Self-service interactive demos that prospects can join without getting on a call.`,
          icon: <img src={LeadIcon} />,
          link: `${config.URL_MARKETING_SITE}/saas-sales-and-marketing`,
        },
        {
          title: 'Real estate tech',
          description: 'Onboard, train, and upsell agents anytime they’re available.',
          icon: <img src={RealestateTechIcon} />,
          link: `${config.URL_MARKETING_SITE}/real-estate-tech`,
        },
        {
          title: 'Real estate brokerage and MLS',
          description: `Training that agents can actually fit into their hectic schedules.`,
          icon: <img src={RealestateIcon} />,
          link: `${config.URL_MARKETING_SITE}/real-estate-brokerage-and-mls`,
        },
        {
          title: 'Course creators and coaches',
          description: `Sell your courses 24/7, even in your sleep.`,
          icon: <img src={CourseIcon} />,
          link: `${config.URL_MARKETING_SITE}/course-creators`,
        },
      ],
    },
  ];
  return (
    <section
      className='md:absolute left-0 rounded-sm hidden bg-white text-xs md:text-sm menu-sub'
      css={css`
        width: 25rem;
      `}
    >
      <div className='flex md:justify-between md:px-2'>
        {SubMenuList.map((item, index) => {
          const itemChilds = item.children;

          return (
            <div className='w-full text-left md:px-2 col-sub' key={index}>
              <ul className='my-2'>
                {itemChilds.map((itemChild, indexChild) => {
                  return (
                    <li key={indexChild}>
                      <a
                        href={itemChild.link}
                        onClick={(e): void => {
                          !itemChild.link && e.preventDefault();
                        }}
                        target={target || itemChild.target}
                        className={`text-gray-28 itemSubmenu flex normal-case no-underline items-center md:items-start md:p-4 py-2 px-4 mr-0 transition-100 rounded-lg hover:${item.bgColor}`}
                      >
                        {/* icon */}
                        <i className='items-center flex mr-4 flex-none w-10 h-10 rounded-full bg-gray-300 p-2'>
                          {itemChild.icon}
                        </i>
                        <div>
                          <h6 className='md:mb-2'>{itemChild.title}</h6>
                          <p className='leading-normal hidden md:block description'>
                            {itemChild.description}
                          </p>
                        </div>
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default UseCasesMenu;
